import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';

export function orgPresentListingTypes(org: ApiOrg) {
  return [
    org.jobs.length > 0 && ('JOB' as const),
    org.internships.length > 0 && ('INTERNSHIP' as const),
    org.volops.length > 0 && ('VOLOP' as const),
    org.events.length > 0 && ('EVENT' as const),
  ].filter(Boolean);
}
